import { useEffect, useMemo, useState } from "react"
import useCurrentCompanyMetadata from "./current-company-metadata"
import { CONNECTORS_IDS } from "../constants/sources"
import useConnectedServices from "./connected-services"
import { ConnectionStatus } from "../api/types"

export const DEFAULT_DEP_VAR_METRIC = "ga_revenue_from_organic_sessions"

let amazonEnabled = false

export default function useDepVar() {
  const [, render] = useState(0)
  const currentCompanyMetadata = useCurrentCompanyMetadata()

  const { findCompanyConnectorInGroup } = useConnectedServices()
  const amazonConnector = findCompanyConnectorInGroup(
    CONNECTORS_IDS.AMAZON_SELLING_PARTNER,
  )
  const amazonVendorConnector = findCompanyConnectorInGroup(
    CONNECTORS_IDS.AMAZON_SELLING_PARTNER_VENDOR,
  )

  const isAmazonConnected =
    amazonConnector?.status === ConnectionStatus.CONNECTED ||
    amazonVendorConnector?.status === ConnectionStatus.CONNECTED

  useEffect(() => {
    amazonEnabled = isAmazonConnected
  }, [isAmazonConnected])

  const toggleAmazon = () => {
    amazonEnabled = !amazonEnabled
    render(x => x + 1)
  }

  const depVarScaler = useMemo(() => {
    const scaler = []
    if (currentCompanyMetadata?.model_props?.ecom?.dep_var_scaler) {
      scaler.push(currentCompanyMetadata.model_props.ecom.dep_var_scaler)
    }
    if (isAmazonConnected && amazonEnabled) {
      scaler.push("amazon_owned_revenue")
    }
    return scaler
  }, [currentCompanyMetadata, amazonEnabled, isAmazonConnected])

  const depVar =
    currentCompanyMetadata?.model_props?.ecom?.dep_var ?? DEFAULT_DEP_VAR_METRIC

  return {
    toggleAmazon: isAmazonConnected ? toggleAmazon : undefined,
    amazonEnabled,
    depVar,
    depVarScaler,
  }
}
